"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchPortalScopes = exports.saveHub = exports.fetchSuggestedAccountName = exports.fetchHub = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("../requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("../RequestEpicDescriptor"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var fetchHub = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.HubActionTypes.FETCH_HUB,
  requestStatusSelector: _selectors.getFetchHubRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchHub
}));
exports.fetchHub = fetchHub;
var fetchSuggestedAccountName = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSuggestedAccountName,
  initiatingActionType: _actions.HubActionTypes.FETCH_SUGGESTED_ACCOUNT_NAME,
  requestStatusSelector: _selectors.getFetchSuggestedAccountNameRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSuggestedAccountName
}));
exports.fetchSuggestedAccountName = fetchSuggestedAccountName;
var saveHub = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setHubValue,
  initiatingActionType: _actions.HubActionTypes.SAVE_HUB,
  requestStatusSelector: _selectors.getSaveHubRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.SaveHub
}));
exports.saveHub = saveHub;
var fetchPortalScopes = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getPortalScopes,
  initiatingActionType: _actions.HubActionTypes.FETCH_PORTAL_SCOPES,
  requestStatusSelector: _selectors.getFetchPortalScopesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchPortalScopes
}));
exports.fetchPortalScopes = fetchPortalScopes;

var _default = (0, _reduxObservable.combineEpics)(fetchHub, fetchSuggestedAccountName, fetchPortalScopes);

exports.default = _default;